import { fetchJSON } from '@bonnet/next/fetch';

import { cmApiUrl } from '@atc/cm-api-url';

export default (value, additionalOptions) => {
    const options = {
        circuitBreaker: {
            id: 'suggestedKeywords',
            timeout: 3000,
            resetTimeout: 30000,
            fallback: {},
        },
        ...additionalOptions,
    };

    return fetchJSON(cmApiUrl('/rest/lsc/marketplace/suggested/keywords/' + value), options);
};
